import React, { createContext, useContext, useState, useCallback } from "react";
import CustomToast from "./CustomToast";

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const handleClose = useCallback((id) => {
    setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
  }, []);

  const showToast = useCallback(
    (
      message,
      severity = "success",
      clearExisting = false,
      // AutoDuration = 7000
      AutoDuration = message?.length > 60 ? 7000 : 4000
    ) => {
      if (clearExisting) {
        setToasts([]);
      }

      const id = new Date().getTime() + Math.random(); // Ensure a unique ID

      setToasts((prevToasts) => [
        ...prevToasts,
        {
          id,
          message,
          severity,
          position: { vertical: "top", horizontal: "right" },
        },
      ]);

      // Schedule the toast to automatically close after the duration
      setTimeout(() => {
        handleClose(id);
      }, AutoDuration);
    },
    [handleClose]
  );

  return (
    <ToastContext.Provider value={showToast}>
      {children}
      {toasts.map((toast, index) => (
        <CustomToast
          key={toast.id}
          open={true}
          handleClose={() => handleClose(toast.id)}
          message={toast.message}
          severity={toast.severity}
          position={toast.position}
          offset={index * 60} // Offset each toast by 60px
          index={index}
          toastsLength={toasts.length}
        />
      ))}
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  return useContext(ToastContext);
};
